module.exports = __webpack_public_path__ + "media/09.de8de865.mp4";